module.exports = __webpack_public_path__ + "static/media/playback.186277af.png";